export default __webpack_public_path__ + "static/media/star.407585a1.svg";